import { Button } from "antd";
import EmptyImage from "../../assets/images/empty-without-text.svg";

interface EmptyProps {
  setShowTable: (value: boolean) => void;
}

export default function Empty({ setShowTable }: EmptyProps) {
  return (
    <div className="py-14 bg-white rounded-md text-center border border-extra-light">
      <div className="flex justify-center items-center h-[100px]">
        <img src={EmptyImage} alt="" />
      </div>
      <h6 className="text-[#bfbfbf] text-base font-medium leading-7 mt-3">
        No records found
      </h6>
      <p className="text-display-body text-sm leading-normal mb-3">
        Monitor full details of your employee meetings and on-site visits.
      </p>
      <Button
        type="primary"
        className="!px-[15px]"
        onClick={() => setShowTable(true)}
      >
        Enable Employee Visit
      </Button>
    </div>
  );
}
